import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'

import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'

import PrimeVue from 'primevue/config';
import ConfirmationService from 'primevue/confirmationservice';

import VueAxios from "vue-axios";
import axios from "axios";
import {authStore} from "./api";
import {dateLocales} from "./api";
import ToastService from "primevue/toastservice";
import DialogService from "primevue/dialogservice";
import Material from '@primeuix/themes/material';
import {definePreset} from "@primeuix/themes";

const preset = definePreset(Material, {
    semantic: {
        primary: {
            50: '{orange.50}',
            100: '{orange.100}',
            200: '{orange.200}',
            300: '{orange.300}',
            400: '{orange.400}',
            500: '{orange.500}',
            600: '{orange.600}',
            700: '{orange.700}',
            800: '{orange.800}',
            900: '{orange.900}',
            950: '{orange.950}'
        }
    }
});

createApp(App)
    .use(router)
    .use(VueAxios, axios)
    .use(authStore)
    .use(PrimeVue, {
        theme: {
            preset: preset,
            options: {
                darkModeSelector: 'none'
            }
        },
        ripple: true,
        locale: {
            accept: 'Tak',
            reject: 'Nie',
            upload: 'Prześlij',
            choose: 'Wybierz',
            ...dateLocales
        }
    })
    .use(ToastService)
    .use(ConfirmationService)
    .use(DialogService)
    .mount('#app')
